import { endOfToday, startOfToday } from 'date-fns';
import { ExportButton } from '../../components/common/ExportButton';
import { Row } from '../../components/common/Row';
import { FilterControl } from '../../components/FilterTagsButton/Filters';
import {
  FilterableFields,
  FilterFormConfig,
} from '../../components/FilterTagsButton/types';
import { useUrlState } from '../../hooks/useUrlState';

const DEFAULT_FILTER_VALUES = {
  created_at_from: startOfToday(),
  created_at_to: endOfToday(),
  // status: { name: 'Todos los estados', value: '*' },
};

const DATE_FIELDS: FilterableFields[] = ['created_at_from', 'created_at_to'];

const filterConfig: FilterFormConfig[] = [
  {
    type: 'date_range',
    field: 'created_at_from',
    fieldTo: 'created_at_to',
    label: 'common.created_at',
  },
  // {
  //   type: 'api_filter',
  //   field: 'status',
  //   filterValuesPath: 'clearings.statuses',
  //   label: 'common.status',
  //   isMultiple: true,
  // },
  {
    type: 'search',
    field: 'search',
    label: 'ID de liquidación',
  },
];

export interface ClearingsFiltersProps {
  filters: Metadata;
}

export function ClearingsFilters({
  filters,
}: ClearingsFiltersProps): JSX.Element {
  return (
    <FilterControl
      defaultValues={DEFAULT_FILTER_VALUES}
      config={filterConfig}
      storageKey="pay_clearings_filters"
      dateFields={DATE_FIELDS}
      rightSideButton={
        <Row margin="0" justifySelf="end" width="auto" gap="1rem">
          <ExportButton
            path="clearings"
            exportName="common.export"
            pathFilters={filters}
          />
        </Row>
      }
    />
  );
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function useClearingsFilters<FilterType>() {
  return useUrlState<Partial<FilterType>>({}, DATE_FIELDS);
}
